import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from 'bootstrap-icons/icons/clock.svg'
import _imports_1 from 'bootstrap-icons/icons/tag.svg'


const _hoisted_1 = { class: "col-sm-12 blog-preview" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  width: "12",
  height: "12",
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  width: "12",
  height: "12",
  src: _imports_1
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("read more")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, [
      _createVNode(_component_router_link, {
        to: '/blog/' + $props.data.slug
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.data.name), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createTextVNode(" " + _toDisplayString(_ctx.$props.data.previewText) + " ", 1),
    _hoisted_2,
    _hoisted_3,
    _createTextVNode(" " + _toDisplayString($setup.publicationDate) + " ", 1),
    _hoisted_4,
    _hoisted_5,
    _createTextVNode(" " + _toDisplayString($props.data.tags) + " ", 1),
    _hoisted_6,
    _createVNode(_component_router_link, {
      to: '/blog/' + $props.data.slug
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}